<template>
	<div>
	    <div class="scontlist">
	    <h3>公司列表</h3>
		<el-form  :inline="true" class="demo-form-inline ">
			<el-form-item >
				<el-input v-model="name" placeholder="请输入公司名"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="getshelist">查询</el-button>
			</el-form-item>
		</el-form>
	    <el-row class="cont">
			
	        <el-col v-for="(item,index) in shelist" :key='index' :span="4" >
	            <div class="grid-content" @click="handlruls(item)">
	                <p>公司名称：{{item.name}}</p>
	                <p>设备数 ：{{item.device_number}}</p>
	                <p>用户数 ：{{item.user_number}}</p>
	                <p>创建时间：{{item.add_time}}</p>
					<!-- <p class="grid-content_item" @click.stop="clear">删除</p> -->
	            </div>
	        </el-col>
			
	    </el-row>
		<div style="margin-top:40px">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handlpage"
				:current-page="1"
				:page-sizes="[10, 20, 30, 40]"
				:pageSize="page_size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
		</el-pagination>
		</div>
	    </div>
	</div>
</template>

<script>
	import {formatDate} from '@/utils/date'
	import methodlist from '@/utils/methods'
import router from '../../router';
	export default{
		data(){
			return{
				shelist:[],
				UserInfo:'',
				name:'',
				total:'',
				page_index:1,
				page_size:30
			}
		},
		methods:{
			clear(){
				
			},
			handleSizeChange(e){
				console.log(e)
				this.page_index = 1
				this.page_size = e
				this.getshelist()
			},
			handlpage(e){
				console.log(`2`,e)
				this.page_index = e
				this.page_size = 30
				this.getshelist()
			},
			handlruls(e){
				console.log(e);
				const user = {
				  name:e.user_name, //this.UserInfo.user_name_save, // 手机号
				  password:e.password, //this.$md5(this.UserInfo.user_pass_save),
				  method: methodlist.ee_login,
				  agent_id:e.id //this.shelist.length==1?'':e.id
				}
				console.log(user)
				this.$serve(user).then(res => {
				  if(res.data.code == 0){
					  res.data.data.user_name_save= e.name //this.UserInfo.user_name_save;
					  res.data.data.user_pass_save = e.password //this.UserInfo.user_pass_save;
						window.localStorage.setItem('user', JSON.stringify(res.data.data))
						this.$router.push({ path: '/home' })
				  }else{
					  if(res.data.code == -3){
					      this.$message({
					        message: '用户名不存在，',
					        type: 'error'
					      });
					  }else if(res.data.code == -6){
					      this.$message({
					        message: '密码错误',
					        type: 'error'
					      });
					  }else{
					      this.$message({
					        message: '登录失败',
					        type: 'error'
					      });
					  }
				  }
				
					
				})
			},
			getshelist(){
				let data = {
					method:'co.agent.list',
					manager_id:this.UserInfo.manager_id,
					name:this.name,
					page_index:this.page_index,
					page_size:this.page_size
				}
				this.$serve(data).then(res=>{
					if(res.data.code==0){
						let data= res.data.data
						console.log(`888`,data)
						this.total = res.data.count
						data.forEach(el => {
						    el.add_time = formatDate(new Date(el.add_time * 1000), 'yyyy-MM-dd hh:mm')
						});
						this.shelist= data
					}
				})
			}
		},
		mounted () {
		    this.UserInfo = JSON.parse(window.localStorage.getItem('user'));
			console.log(this.UserInfo);
			this.getshelist()
		}
	}
</script>

<style lang="less" scoped>
 .scontlist{
    width: 100%;
    height: auto;
    h3{
        margin-bottom: 25px;
        text-align: center;
    }
	.demo-form-inline{
		display: flex;
    justify-content: center;
	}
    .cont{
        
        .grid-content{
            border: 1px solid #ccc;
            height: 150px;
            margin-left: 20px;
            border-radius:10px;
            cursor: pointer;
            p{
                padding: 7px 0 0 7px;
            }
			.grid-content_item{
				color: red;
				width: 30%;
				height: 20px;
				line-height: 20px;
				text-align: center;
				border: 1px solid #000;
				padding:5px 0;
				margin-left: auto;
			}
        }
    }
    
}
</style>